/* eslint-disable no-unused-vars */
import React, { useState } from "react";

import { DatePickerCalendar } from "./DatePickerCalendar/DatePickerCalendar";
import { DatePickerSelector } from "./DatePickerSelector/DatePickerSelector";

import DatePickerModule from "./DatePicker.module.scss";
import { Button, HStack, Typography } from "..";

export interface DatePickerProps {
  selectedDate: Date;
  currentDate: Date;
  onChange: (newDate: Date) => void;
  onCancel: () => void;
  onSubmit: (date: Date) => void;
}

export const DatePicker: React.FC<DatePickerProps> = ({ selectedDate, currentDate, onChange, onCancel, onSubmit }) => {
  const [shownDate, setShownDate] = useState(new Date(selectedDate));

  return (
    <div className={DatePickerModule.DatePicker}>
      <DatePickerSelector shownDate={shownDate} setShownDate={setShownDate} currentDate={currentDate} />
      <DatePickerCalendar selectedDate={selectedDate} shownDate={shownDate} currentDate={currentDate} onChange={onChange} />
      <div className={DatePickerModule.MobileButtonContainer}>
        <div>
          <Button
            className={`text-size-18 ${DatePickerModule.CardButtonLeft}`}
            label="Select Date"
            size="medium"
            type="submit"
            onClick={() => onSubmit(shownDate)}
          />
        </div>
        <HStack className="pb-2 justify-content-center">
          <Typography className="my-0 ml-0 mr-0 text-size-18 text-medium clickable" onClick={onCancel}>
            Cancel
          </Typography>
        </HStack>
      </div>
      <div className={DatePickerModule.ButtonContainer}>
        <Button
          type="button"
          className={`text-size-18 ${DatePickerModule.CardButtonLeft}`}
          label="Cancel"
          varient="secondary"
          size="small"
          onClick={onCancel}
        />
        <Button
          type="button"
          className={`text-size-18 ${DatePickerModule.CardButtonRight}`}
          label="Select Date"
          size="small"
          onClick={() => onSubmit(shownDate)}
        />
      </div>
    </div>
  );
};
